export default function PHP_ftp_systype() {
  return (
    <div>
      <h1>PHP_ftp_systype</h1>
    </div>
  );
}
